import { useMemo } from "react";

import { queryGetCorpEmployeeAccess } from "@type/api/corporation";
import { useCorporationStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

import { TGetCorpEmployeeAccessReq } from "@type/api/corporation/types";
import { TBooleanRecord } from "types/index";

interface UseGetEmployeeAccessProps {
  params?: TGetCorpEmployeeAccessReq;
}

export const useGetEmployeeAccess = ({ params }: UseGetEmployeeAccessProps) => {
  const queryGetEmployeeAccessKey = useMemo(() => {
    return queryGetCorpEmployeeAccess._key(params);
  }, [params]);

  const onSetCorpAccessRight = useCorporationStore(
    (state) => state.onSetCorpAccessRight
  );

  const { isLoading: isLoadingGetEmployeeAccess } = useQueryWithCallbacks({
    queryKey: queryGetEmployeeAccessKey,
    enabled: !!params?.userId && !!params.corpId,
    queryFn: () => queryGetCorpEmployeeAccess(params),
    onSuccess: (res) => {
      const objAccess: TBooleanRecord = {};
      for (const access of res.access) {
        objAccess[access.id] = access.status;
        for (const subAccess of access.sub) {
          objAccess[subAccess.id] = subAccess.status;
        }
      }
      onSetCorpAccessRight(objAccess);
    },
  });

  return {
    isLoadingGetEmployeeAccess,
  };
};
